<template>
  <div 
    class="museum mp-wrapper"
    v-if="pagesData.data.length"
  >
    <!-- <Navigation /> -->
    <!-- <div class="margin-left"></div> -->
    <div
      class="mp-container"
    >
      <div 
        class="content "
      >
        <h1
        >Herzlich willkommen</h1>
        <h2
        >im Museum Pankow, Standort Heynstr. 8</h2>
        <img 
          src="/img/treppenhaus.jpg"
          alt="Treppenhaus im Museum Pankow"
        >
        <div v-html="home.content" />
      </div>
    </div>
    <!-- <div class="margin-right">right</div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
// import Navigation from '@/components/Navigation'

export default {
  name: 'home',
  components: {
    // Navigation
  },
  data () {
    return {

    }
  },
  methods: {
    
  },
  computed: {
    ...mapGetters({
      selectedVideo: 'getSelectedVideo',
      player: 'getPlayerStatus',
      pagesData: 'getPagesData',
      home: 'getHomepageData'
    })
  },
  created () {
    this.$store.state.selectedVideo = null
  }
}
</script>
<style lang="scss" scoped>
  @import '@/scss/custom.scss';
  .museum {
    position: relative;
    min-height: 100vh;
    .content {
      background-color: $sand-dark-80;
      max-width: 1200px;
      margin: 10rem 12rem 0rem 4rem;
      padding: 2rem 4rem;
      font-size: $font-text-md;
      line-height: 1.8;
      @media (max-width: $laptop) {
        margin: 7rem 3rem 0rem 3rem;
        line-height: 1.6;
      }
      @media (max-width: $tabletL) {
        font-size: 1rem;
        margin: 6rem 1rem 0rem 1rem;
      }
      img {
        display: block;
        float: right;
        margin: 0 0 1rem 1rem;
        max-width: 40%;
        @media (max-width: $tabletP) {
          display: none;
        }
      }
      h1, h2 {
        font-family: 'Tangerine', serif;
        font-weight: 700;
        font-size: 4.4rem;
        color: $red-light;
        margin: 0;
        @media (max-width: $tabletL) {
          font-size: 4rem;
        }
        @media (max-width: $tabletP) {
          font-size: 2rem;
        }
      }
      h2 {
        font-size: 2.8rem;
        font-weight: 400;
        margin: 0 0 1.2rem 0;
        @media (max-width: $tabletL) {
          font-size: 2.2rem;
        }
        @media (max-width: $tabletP) {
          font-size: 1.2rem;
        }
      }
    }
  }
</style>